/**
 * LaunchDarkly flag keys (must match dashboard keys).
 * @see https://docs.launchdarkly.com/sdk/client-side/react/react-web#using-useflags
 */
export const FEAT_ANTIVIRUS_CHECK_IN_FILE_UPLOAD =
  'featAntivirusCheckInFileUpload';

export const isAntivirusFileScanEnabled = (flags) =>
  flags?.[FEAT_ANTIVIRUS_CHECK_IN_FILE_UPLOAD] === true;

export const FEAT_QUICK_LINKS_INSTITUTION_LEVEL =
  'webAppFtHomeQuickLinks202607';

export const isQuickLinksInstitutionLevelEnabled = (flags) =>
  flags?.[FEAT_QUICK_LINKS_INSTITUTION_LEVEL] === true;

export const FEAT_HOME_OUTLOOK_WIDGET = 'webAppFtHomeOutlookWidget202608';

export const isHomeOutlookWidgetEnabled = (flags) => {
  return flags?.[FEAT_HOME_OUTLOOK_WIDGET] === true;
};
